// extracted by mini-css-extract-plugin
module.exports = {"label":"c6e8ba5398--label--1xoN6"};